module.exports = __webpack_public_path__ + "img/ercode_sx.f3aa0f7e.png";